
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: '[my-embed]',
  template: require('./embed.modal.html'),
  styles: [require('./embed.modal.scss')]
})
export class EmbedModalComponent implements OnInit, OnDestroy{
  public content: String;
  public title: String;
  public isReady: Boolean = false;
  public metadata: any= {};
  constructor() {
     /* meta data info */
     this.metadata.url = 'https://www.sbo.net/';
     this.metadata.domain = 'https://www.sbo.net/';
     this.metadata.opengraph = 'img/opengraph.png';
     this.metadata.client = 'SBO';
  }

  ngOnInit() {
    /* embed info */
     this.title = 'Love this tool? Embed it on your website';
     this.content = `<a href="${this.metadata.url}" target="_blank"><img src="${this.metadata.url + this.metadata.opengraph }" width="600"/></a><span style="font-size: 12px;"><a href="${this.metadata.url}">See interactive version here</a> (via <a href="${this.metadata.domain}">${this.metadata.client}</a>).</span>`;
  }

  ngOnDestroy() {
     this.isReady = false;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/modals/embed/embed.modal.ts